export default {
  primaryFontFamily: '"VT323", monospace',
};
